var _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMlb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_105_3",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 105 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.833,
    height: 28,
    viewBox: "0 0 89.833 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4073",
    "data-name": "\\uADF8\\uB8F9 4073",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3744",
    "data-name": "\\uADF8\\uB8F9 3744",
    transform: "translate(-222.106 -399.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2894",
    "data-name": "\\uD328\\uC2A4 2894",
    d: "M251.536,401.006,241.06,412.03l-3.847-11.024h-7.7l0,.006-1.63-.006.981,2.462-5.535,18.267-1.222,4.271h0v0h7.725l3.6-11.972,2.662,6.179h5.014l6.377-6.179L243.885,426h7.832l7.515-25Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2895",
    "data-name": "\\uD328\\uC2A4 2895",
    d: "M341.691,408.557c-.295.984-1.282,2.037-3.43,2.037h-4.88l1.224-4.074h4.879c2.147,0,2.5,1.054,2.207,2.036m-2.478,9.726a3.367,3.367,0,0,1-3.528,2.212h-5.279l1.317-4.39H337c2.149,0,2.527,1.125,2.209,2.178m10.2-9.944c1.3-4.319-1.154-7.331-7.778-7.331h-13.2v.006l-1.683-.008.991,2.294-5.978,20.289-2.573,2.417h15.6c5.682,0,10.795-.523,12.231-5.3,1.056-3.511.006-6.487-1.1-7.12C347.061,413.063,348.557,411.182,349.412,408.339Z",
    transform: "translate(-41.518 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2896",
    "data-name": "\\uD328\\uC2A4 2896",
    d: "M298.554,420.529H287.7l5.868-19.521h-7.833v.005l-1.659-.007,1.026,2.419-6.14,20.179-2.465,2.4H299.43l2.192-7.053C297.21,421.235,298.819,420.39,298.554,420.529Z",
    transform: "translate(-23.124 0)",
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2480",
    "data-name": "\\uC0AC\\uAC01\\uD615 2480",
    width: 89.833,
    height: 28,
    transform: "translate(0)",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMlb);
export default __webpack_public_path__ + "static/media/logoMlb.73359f3d77e34232436e15b70ba007fe.svg";
export { ForwardRef as ReactComponent };